import { server } from '../server';
export var PriceHistoryTimeframe;
(function (PriceHistoryTimeframe) {
    PriceHistoryTimeframe["DAY"] = "day";
    PriceHistoryTimeframe["HOUR"] = "hour";
    PriceHistoryTimeframe["MINUTE"] = "minute";
})(PriceHistoryTimeframe || (PriceHistoryTimeframe = {}));
export const getPriceHistory = async (params) => {
    const { beforeTimestamp, timeframe, limit, token, chainLayer } = params;
    const before_timestamp = beforeTimestamp ?? Math.floor(+Date.now() / 1000);
    const queryParams = new URLSearchParams({
        before_timestamp: before_timestamp.toString(),
        limit: limit.toString(),
        timeframe,
        token,
    });
    const response = await server.get({
        endpoint: 'price-history',
        queryParams,
        chainLayer,
    });
    if (!response.ok) {
        throw new Error(`Error fetching price-history: ${response.statusText}`);
    }
    const data = await response.json();
    return data;
};
